function createIdempotencyKey() {
    // One key identifies one user save, allowing the API to replay retries safely.
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }

    // Keep compatibility with browsers that do not expose crypto.randomUUID().
    var randomValues = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        window.crypto.getRandomValues(randomValues);
    }
    else {
        for (var index = 0; index < randomValues.length; index++) {
            randomValues[index] = Math.floor(Math.random() * 256);
        }
    }

    randomValues[6] = (randomValues[6] & 0x0f) | 0x40;
    randomValues[8] = (randomValues[8] & 0x3f) | 0x80;
    var hex = Array.from(randomValues, value => value.toString(16).padStart(2, '0'));
    return [
        hex.slice(0, 4).join(''),
        hex.slice(4, 6).join(''),
        hex.slice(6, 8).join(''),
        hex.slice(8, 10).join(''),
        hex.slice(10, 16).join(''),
    ].join('-');
}

export default createIdempotencyKey;
